// Homeslider.jsx
import React, { useEffect, useRef, useState } from "react";
import "./Homeslider.css";
import { Link } from "react-router-dom";
import img1 from "../../Assets/Images/img1.jpeg"
import logo from "../../Assets/Images/logo.png"
import bullVideo from "../../Assets/Images/bull.mp4"
import graphVideo from "../../Assets/Images/graph1.mp4"
import candleVideo from "../../Assets/Images/candle.mp4"
import graph2Video from "../../Assets/Images/graph2.mp4"

const Homeslider = () => {
  const [itemActive, setItemActive] = useState(0);
  const sliderInterval = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [videoErrors, setVideoErrors] = useState({});

  const handleVideoError = (index) => {
    setVideoErrors(prev => ({ ...prev, [index]: true }));
  };

  const items = [
    {
      img: bullVideo,
      title: "Market Momentum",
      description: "Experience the dynamic energy of the stock market with our professional analysis and real-time insights for strategic investment decisions.",
      category: "Momentum",
      type: "video"
    },
    {
      img: graphVideo,
      title: "Data Analytics",
      description: "Advanced chart analysis and data visualization tools to help you make informed investment decisions with comprehensive market insights.",
      category: "Analytics",
      type: "video"
    },
    {
      img: candleVideo,
      title: "Candlestick Analysis",
      description: "Master the art of candlestick pattern recognition for precise market timing and profitable trading opportunities.",
      category: "Patterns",
      type: "video"
    },
    {
      img: graph2Video,
      title: "Technical Analysis",
      description: "Comprehensive technical analysis tools and indicators to identify market trends and make data-driven investment decisions.",
      category: "Technical",
      type: "video"
    },
    {
      img: img1,
      title: "Market Research",
      description: "We specializes in stock market analysis, providing professional insights and personalized financial strategies to empower informed investments.",
      category: "Market",
      type: "image"
    }
  ];



  const countItem = items.length;

  const handleNext = () => {
    setItemActive((prev) => (prev + 1) % countItem);
  };

  const handlePrev = () => {
    setItemActive((prev) => (prev - 1 + countItem) % countItem);
  };

  const resetSliderInterval = () => {
    if (sliderInterval.current) {
      clearInterval(sliderInterval.current);
      sliderInterval.current = null;
    }
    if (!isHovered) {
      sliderInterval.current = setInterval(() => {
        handleNext();
      }, 5000);
    }
  };

  useEffect(() => {
    resetSliderInterval();
    return () => clearInterval(sliderInterval.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset timer on hover/slide; stable interval logic
  }, [isHovered, itemActive]);

  // Start the interval when component mounts
  useEffect(() => {
    resetSliderInterval();
    return () => {
      if (sliderInterval.current) {
        clearInterval(sliderInterval.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const thumbnailsRef = useRef([]);

  const setPositionThumbnail = (index) => {
    const thumbnailActive = thumbnailsRef.current[index];
    if (thumbnailActive) {
      const rect = thumbnailActive.getBoundingClientRect();
      if (rect.left < 0 || rect.right > window.innerWidth) {
        thumbnailActive.scrollIntoView({ behavior: "smooth", inline: "nearest" });
      }
    }
  };

  useEffect(() => {
    setPositionThumbnail(itemActive);
  }, [itemActive]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="modern-slider">
      {/* Navigation Header */}
      <nav className="slider-nav">
        <div className="nav-logo">
                  <img src={logo} alt="Trillion Stock Research" className="nav-logo-img" />
        <span className="nav-logo-text">Trillion Stock Research</span>
        </div>
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className="nav-link">Home</Link></li>
          <li><Link to="/about" className="nav-link">About</Link></li>
          <li><Link to="/services" className="nav-link">Services</Link></li>
          <li><Link to="/pricing" className="nav-link">Pricing</Link></li>
          <li><Link to="/payments" className="nav-link">Payments</Link></li>
          <li><Link to="/policy" className="nav-link">Policy</Link></li>
          <li><Link to="/complaints" className="nav-link">Complaints</Link></li>
          <li><Link to="/contact" className="nav-link">Contact</Link></li>
        </ul>
      </nav>

      {/* Main Slider */}
      <div 
        className="slider-container"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="slider-content">
          {items.map((item, index) => (
            <div
              key={index}
              className={`slider-item ${index === itemActive ? "active" : ""}`}
            >
              <div className="slider-image-container">
                {item.type === "image" ? (
                  <img src={item.img} alt={item.title} className="slider-image" />
                ) : videoErrors[index] ? (
                  <img src={img1} alt={item.title} className="slider-image" />
                ) : (
                  <video 
                    src={item.img} 
                    controls={false} 
                    autoPlay 
                    muted 
                    loop 
                    playsInline
                    preload="auto"
                    className="slider-image"
                    onError={() => handleVideoError(index)}
                    aria-label={`${item.title} video`}
                    role="img"
                  >
                    Your browser does not support the video tag.
                  </video>
                )}
                <div className="slider-overlay"></div>
              </div>
              <div className="slider-text-content">
                <span className="slider-category">{item.category}</span>
                <h2 className="slider-title">{item.title}</h2>
                <p className="slider-description">{item.description}</p>
                <button className="slider-cta">Learn More</button>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button className="slider-arrow prev" onClick={handlePrev}>
          <span className="arrow-icon">‹</span>
        </button>
        <button className="slider-arrow next" onClick={handleNext}>
          <span className="arrow-icon">›</span>
        </button>

        {/* Progress Bar */}
        <div className="slider-progress">
          {items.map((_, index) => (
            <div
              key={index}
              className={`progress-item ${index === itemActive ? "active" : ""}`}
              onClick={() => setItemActive(index)}
            >
              <div className="progress-bar"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Tagline Section */}
      <div className="slider-tagline">
        <h1 className="tagline-title">Trillion Stock Research</h1>
        <p className="tagline-subtitle">Authorized By SEBI</p>
      </div>
    </div>
  );
};

export default Homeslider;